export const AUTHORISE_API_CALLS = "Auth/Authorise";
export const ISSUE_FORM_DATA = "Masters/GetIssueFormMasters";
export const SUBMIT_FORM_DATA = "ReportIssue/Submit";
export const SEND_EMAIL_VERIFICATION = "ReportIssue/VerifyEmail";
export const VERIFY_USER = "ReportIssue/VerifyUserEmailFromToken";
export const VERIFY_FORM_ACCESS = "ReportIssue/VerifyFormAccess";
export const CHANGE_PASSWORD = "profile/change-password";
export const CREATE_ACCOUNT = "profile/create-account";
export const USER_INFO = "profile/ldap-status";
export const UPLOAD_FILE = "File/UploadFiles";

export const LOGIN = "/auth/token/";
export const GET_TODOS = "/api/features/todo/";
export const MY_PROFILE = "/api/myprofile/";
export const FEEDBACK = "/api/features/feedback/";
export const FEEDBACKUNFILTERED = "/api/features/feedback/unlisted/";
export const GET_QUIZ = "/api/features/quiz/questions/";
export const SUBMIT_QUIZ = "/api/features/quiz/question-answers";
export const AVAILABLE_SURVEY = "/api/features/survey/available";
export const COMPLETED_SURVEY = "/api/features/survey/completed";

// Company Admin Panel

export const GET_EMPLOYEES = "/api/user/user";
